<companyid-content-wrapper
    classNames="bg-gradient-to-r from-[#3e57f0] via-[#24328a] to-[#24328a] items-center my-80px mob:pb-40px tab:mx-5 rounded-14px mob:rounded-none box-shadow-5 border border-solid border-blue mob:flex-col-reverse mob:items-start mob:mx-0 mob:h-fit mob:mb-0"
>
    <div
        class="flex flex-col gap-y-15px text-white p-40px mob:px-5 min-h-[430px] tab:min-h-[630px] mob:max-h-full max-w-[570px] tab:w-[350px] mob:min-w-full text-medium-medium relative"
    >
        <span class="text-h3-bold mob:text-center" i18n=":@@efficient-accounting-integration"
            >Efficient Accounting Integration</span
        >
        @for (item of efficientAccountingItems; track item) {
            <span>✓ {{ item }}. </span>
        }
        <div class="flex gap-x-30px tab:flex-col tab:gap-y-30px mt-auto mob:gap-x-15px mob:mt-0 mob:justify-center">
            <a i18n="@@button-get-started" routerLink="/pricing" class="button-ghost-white tab:w-full"> Get Started </a>
            <a i18n="@@button-lear-more" routerLink="/features" class="button-white-outline tab:w-full"> Learn More </a>
        </div>

        <companyid-avatar-with-message
            classNames="tab:hidden mob:hidden absolute left-[150px] mt-35px"
            avatarImg="woman"
            [title]="avatarTitle"
            [position]="avatarPosition"
            [subtitle]="avatarSubtitle"
        />
    </div>
    <div class="flex flex-col mob:max-h-[400px] relative items-end">
        <img
            [ngSrc]="'export' | asset: 'home/efficient-accounting-integration' : 'webp'"
            alt="export"
            width="253"
            height="140"
            class="absolute bottom-[320px] tab:bottom-[520px] mob:left-[calc(100%-255px)] mob:top-[-35px] mob:z-10"
        />
        @for (img of boxImages; track img.name) {
            <img
                [ngSrc]="img.name | asset: 'home/efficient-accounting-integration' : 'webp'"
                [width]="img.width"
                [height]="img.height"
                [class]="img.className"
                alt="screen"
            />
        }
    </div>
</companyid-content-wrapper>
